module.exports = __webpack_public_path__ + "static/img/guide.fe0b5508.svg";